import { useLanguage } from "@/context/LanguageContext";
import { useConsentManager } from "@/components/consent/useConsentManager";
import { Link } from "react-router-dom";

const ConsentHeader = ({ copy }) => (
  <div className="consent-header" data-testid="consent-header">
    <h3 className="consent-title" data-testid="consent-title">
      {copy.consent.title}
    </h3>
    <p className="consent-description" data-testid="consent-description">
      {copy.consent.description}
    </p>
    <Link
      to="/privacy"
      className="consent-link"
      data-testid="consent-privacy-link"
    >
      {copy.consent.privacyLinkLabel}
    </Link>
  </div>
);

const ConsentOptions = ({ copy, preferences, onToggle }) => (
  <div className="consent-preferences" data-testid="consent-preferences">
    <label className="consent-toggle" data-testid="consent-analytics-toggle">
      <input
        type="checkbox"
        checked={preferences.analytics}
        onChange={() => onToggle("analytics")}
        data-testid="consent-analytics-checkbox"
      />
      <span className="consent-toggle-text">
        <span className="consent-toggle-label" data-testid="consent-analytics-label">
          {copy.consent.analytics.label}
        </span>
        <span className="consent-toggle-description" data-testid="consent-analytics-description">
          {copy.consent.analytics.description}
        </span>
      </span>
    </label>

    <label className="consent-toggle" data-testid="consent-marketing-toggle">
      <input
        type="checkbox"
        checked={preferences.marketing}
        onChange={() => onToggle("marketing")}
        data-testid="consent-marketing-checkbox"
      />
      <span className="consent-toggle-text">
        <span className="consent-toggle-label" data-testid="consent-marketing-label">
          {copy.consent.marketing.label}
        </span>
        <span className="consent-toggle-description" data-testid="consent-marketing-description">
          {copy.consent.marketing.description}
        </span>
      </span>
    </label>
  </div>
);

const ConsentActions = ({ copy, onReject, onSave, onAccept }) => (
  <div className="consent-actions" data-testid="consent-actions">
    <button
      type="button"
      className="consent-button secondary"
      onClick={onReject}
      data-testid="consent-reject-button"
    >
      {copy.consent.actions.rejectAll}
    </button>
    <button
      type="button"
      className="consent-button tertiary"
      onClick={onSave}
      data-testid="consent-save-button"
    >
      {copy.consent.actions.save}
    </button>
    <button
      type="button"
      className="consent-button primary"
      onClick={onAccept}
      data-testid="consent-accept-button"
    >
      {copy.consent.actions.acceptAll}
    </button>
  </div>
);

const ConsentBanner = () => {
  const { copy } = useLanguage();
  const {
    isVisible,
    preferences,
    handleToggle,
    handleSave,
    handleAcceptAll,
    handleRejectAll,
  } = useConsentManager();

  if (!isVisible) {
    return null;
  }

  return (
    <div className="consent-banner" data-testid="consent-banner">
      <div className="consent-content" data-testid="consent-content">
        <ConsentHeader copy={copy} />
        <ConsentOptions copy={copy} preferences={preferences} onToggle={handleToggle} />
        <ConsentActions
          copy={copy}
          onReject={handleRejectAll}
          onSave={handleSave}
          onAccept={handleAcceptAll}
        />
      </div>
    </div>
  );
};

export default ConsentBanner;
